import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import store from 'store';
import { Avatar, Dropdown, Menu, Modal, Button } from 'antd';
import {
  UserOutlined,
  DownOutlined,
  CloseCircleFilled,
  LogoutOutlined,
} from '@ant-design/icons';
import { onExit, hrefUserHomeInfo, checkIsLaunchpad } from '@/utils/util';
import Organization from '@/assets/images/organization.png';
import './IndexHead.styl';
import { getParam } from 'ruigu-utils';
class IndexHead extends Component {
  state = {
    searchResult: [],
    keyword: '',
    modalVisible: false,
    userInfo: {},
  };

  componentDidMount() {
    const userInfo = store.get('userInfo') || {};
    this.setState({
      userInfo,
    });
  }

  componentDidUpdate(prevProps, prevState) {
// console.log(prevProps, prevState);
  }

  /**
   * input
   */
  onSearch({ target: { value = '' }, keyCode = '' } = {}) {
    if (value === '') {
      this.setState({ searchResult: [] });
    }

    this.setState({ keyword: value });
  }

  /**
   * input enter
   */
  onSearchEnter({ keyCode = '' } = {}) {
    if (keyCode === 13) {
      this.onSearchResult();
    }
  }

  /**
   * search button click
   */
  onSearchResult() {
    if (this.state.keyword === '') return;
    this.setState({
      searchResult: this.props.allModule.filter((item) =>
        item.title.includes(this.state.keyword),
      ),
    });
  }

  onClickClearKeyword() {
    this.setState({ keyword: '', searchResult: [] });
    this.searchInput.value = '';
    this.searchInput.focus();
  }

  onClickSearchResult(params) {
    this.setState({ searchResult: [] });
    this.props.onClickModule({
      ...params,
      id: String(params.id),
      path:
        params.type === 1
          ? `${window.location.origin}/menuLayout`
          : params.path,
      backPath:
        params.type === 1
          ? `${window.location.origin}/menuLayout`
          : params.backPath,
    });
  }

  onClickOrganization() {
    this.setState({
      modalVisible: !this.state.modalVisible,
    });
  }

  // 点击菜单（聚合+单个）
  itmeClick(params) {
    if (params.type === 1) {
      this.props.onClickModule({
        ...params,
        id: String(params.id),
        path: `${window.location.origin}/menuLayout`,
        backPath: `${window.location.origin}/menuLayout`,
      });
    } else {
      this.props.onClickModule(params);
    }
  }

  onClickModalModule(item) {
    document
      .querySelector('.all-menu-bg')
      .setAttribute('style', 'opacity:1;visibility:hidden;');
    setTimeout(() => {
      const queryMenu = document.querySelector('.all-menu-bg');
      if (queryMenu) {
        queryMenu.removeAttribute('style');
      }
    }, 100);
    this.itmeClick(item);
  }

  goBackHome() {
    store.set('openModule', null);
    store.set('openModuleOpenInfo', null);
    this.props.history.push('/?backFlag=1');
  }

  render() {
    const { keyword, searchResult, modalVisible } = this.state;

    const userMenu = (
      <Menu
        className={`menu-item-hover menu-item-user ${
          this.props.isTenant ? 'tenant-menu' : 'ruigu-menu'
        }`}
      >
        {checkIsLaunchpad() && (
          <Menu.Item>
            <div
              className="flex-row-center-center"
              onClick={() => this.props.onClickModule(hrefUserHomeInfo())}
            >
              <UserOutlined />
              <span className="m-l-5">个人主页</span>
            </div>
          </Menu.Item>
        )}
        <Menu.Item>
          <div className="flex-row-center-center" onClick={() => onExit()}>
            <LogoutOutlined />
            <span className="m-l-5">退出登录</span>
          </div>
        </Menu.Item>
      </Menu>
    );

    const tenantSelectMenu = (
      <Menu
        className={`menu-item-hover tenant-menu-select ${
          this.props.isTenant ? 'tenant-menu' : 'ruigu-menu'
        }`}
      >
        <Menu.Item>
          <div
            className="flex-row-center-center"
            onClick={() => this.props.history.push('/tenantSelect')}
          >
            <span className="menu-item-iconfont">
              <i className="iconfont icon-Swap1" />
            </span>
            <span className="m-l-5">选择工作台</span>
          </div>
        </Menu.Item>
      </Menu>
    );

    const allMenu = (
      <div className="all-menu-bg">
        <div className="all-menu-wrapper m-0-a">
          {this.props.headerMenu
            .filter((item) => item.id)
            .map(({ id, title, children }) => {
              return (
                <div className="system-list-item" key={`headerMenu${id}`}>
                  <h2 className="system-name fs-18-imp m-t-10 bold main-color">
                    {title}
                  </h2>
                  <div className="system-module-wrapper flex-col-start-start">
                    {children.map((item, idx) => {
                      if (item.path || item.type === 1) {
                        return (
                          <span
                            className="system-module-name fs-14-imp m-l-8 pointer"
                            key={`headerMenu${item.id}${idx}`}
                            onClick={this.onClickModalModule.bind(this, item)}
                          >
                            {item.title}
                          </span>
                        );
                      } else if (item.children && item.children.length > 0) {
                        return (
                          <>
                            <h3 className="system-module-name fs-14-imp bold m-l-8">
                              {item.title}
                            </h3>
                            {item.children.map((it) => (
                              <span
                                className="system-module-name fs-14-imp m-l-15 pointer"
                                key={`headerMenu${it.id}${idx}`}
                                onClick={this.onClickModalModule.bind(this, it)}
                              >
                                {it.title}
                              </span>
                            ))}
                          </>
                        );
                      }
                    })}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );

    const searchResultWrapper =
      searchResult.length > 0 ? (
        <div className="search-result-wrapper">
          {searchResult.map((ite) => {
            return (
              <span
                className="display-block search-result text-color-secondary pointer text-ellipsis fs-12"
                key={ite.id}
                onClick={this.onClickSearchResult.bind(this, ite)}
              >
                {ite.title}
              </span>
            );
          })}
        </div>
      ) : null;

    return (
      <div
        className={`index-header-bg ${this.props.isTenant ? 'tenant-bg' : ''}`}
      >
        <div className="index-header m-0-a flex-row-between-center">
          <div className="flex-row-start-center">
            {/*logo*/}
            {checkIsLaunchpad() ? (
              <Dropdown overlay={tenantSelectMenu} placement="bottomRight">
                <div className="logo-wrapper flex-row-start-center pointer">
                  <img
                    src={this.props.companyLogo}
                    alt="logo"
                    className="display-block logo"
                  />
                  <h1 className="system-title fs-20 bold text-center m-l-5">
                    {this.props.companyName}
                  </h1>
                  <DownOutlined className="m-l-10 more-icon system-title" />
                </div>
              </Dropdown>
            ) : (
              <div className="logo-wrapper flex-row-start-center">
                <img
                  src={this.props.companyLogo}
                  alt="logo"
                  className="display-block logo"
                />
                <h1 className="system-title fs-20 bold text-center m-l-5">
                  {this.props.companyName}
                </h1>
              </div>
            )}

            {/*all menu button*/}
            {this.props.isTenant ? (
              this.props.headerMenu.length ? (
                <div className="flex-row-start-center headerMenu-box">
                  {this.props.headerMenu.map((item, index) => (
                    <div
                      key={`headerMenu${index}`}
                      className={`flex-row-center-center headerMenu-item pointer ${
                        Number(this.props.activeIndex) === index
                          ? 'headerMenu-item-active'
                          : ''
                      }`}
                      onClick={() => this.props.onClickActive(index)}
                    >
                      {item}
                    </div>
                  ))}
                </div>
              ) : ''
            ) : (
              <>
                <div className="all-menu flex-row-end-center pointer">
                  <span className="all-menu-title text-center fs-12">全部</span>
                  <DownOutlined className="fs-10 all-menu-icon" />

                  {/*all menu wrapper*/}
                  {allMenu}
                </div>

                {/*search*/}
                <div className="search-wrapper flex-row-start-center">
                  <input
                    type="text"
                    ref={(searchInput) => (this.searchInput = searchInput)}
                    className="search-input fs-12"
                    placeholder="请输入搜索内容"
                    maxLength={20}
                    onKeyUp={this.onSearchEnter.bind(this)}
                    onInput={this.onSearch.bind(this)}
                  />
                  <div
                    className="button-wrapper flex-row-center-center pointer"
                    onClick={this.onSearchResult.bind(this)}
                  >
                    <span className="search-title fs-12">搜索</span>
                  </div>

                  {keyword !== '' ? (
                    <CloseCircleFilled
                      className="clear-input fs-14 pointer"
                      onClick={this.onClickClearKeyword.bind(this)}
                    />
                  ) : (
                    ''
                  )}
                  {searchResultWrapper}
                </div>
              </>
            )}
          </div>

          {/*user*/}
          <div className="user-wrapper pointer flex-row-end-center">
            {/* 任务工作台返回中台 */}
            {getParam('board_group') === '2' && (
              <Button
                type="primary"
                size="small"
                className="m-r-20"
                onClick={() => this.goBackHome()}
              >
                返回中台
              </Button>
            )}

            {/* 用户头像名称 */}
            <Dropdown overlay={userMenu} placement="bottomRight">
              <div className="flex-row-end-center">
                <Avatar
                  size={30}
                  icon={
                    this.state.userInfo.avatar ? (
                      <img src={this.state.userInfo.avatar} />
                    ) : (
                      <UserOutlined />
                    )
                  }
                />
                <span className="m-l-10">{this.state.userInfo.nickname}</span>
                {/* <DownOutlined className="m-l-10 more-icon" /> */}
                <span className="user-wrapper-iconfont">
                  <i className="iconfont icon-Arrow_Down" />
                </span>
              </div>
            </Dropdown>
          </div>

          {/*organization*/}
          <Modal
            title="产品技术部组织架构"
            visible={modalVisible}
            footer={null}
            width={1200}
            onCancel={this.onClickOrganization.bind(this)}
          >
            <img
              src={Organization}
              alt="产品技术部组织架构"
              className="organization-img m-0-a"
            />
          </Modal>
        </div>
      </div>
    );
  }
}

export default withRouter(IndexHead);
